import { render, staticRenderFns } from "./MainTopbar.vue?vue&type=template&id=2c020a8e&scoped=true&"
import script from "./MainTopbar.vue?vue&type=script&lang=js&"
export * from "./MainTopbar.vue?vue&type=script&lang=js&"
import style0 from "./MainTopbar.vue?vue&type=style&index=0&id=2c020a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c020a8e",
  null
  
)

export default component.exports